'use client'

import { useMemo } from 'react'
import { useTranslations } from 'next-intl'
import { useGetFormilyBockQuery } from '@segway/core'

import { Link } from '@/i18n/navigation'

import { DirectionIcon } from '../icons'

type QuickLinkData = {
  term: string
  is_enable: string
  link: string
}

const QuickLink = () => {
  const t = useTranslations('Common')
  const { data } = useGetFormilyBockQuery({
    identify: 'search_terms',
  })

  const quickLinkList = useMemo(() => {
    if (data?.formilyBlock?.block_data) {
      const parseData = data?.formilyBlock?.block_data && JSON.parse(data?.formilyBlock?.block_data)
      const arr: QuickLinkData[] = parseData
        ? (parseData.terms as QuickLinkData[]).filter((item) => Number(item.is_enable)).slice(0, 5)
        : []
      return arr
    }

    return []
  }, [data?.formilyBlock?.block_data])

  return (
    <>
      {quickLinkList?.length > 0 && (
        <div className="mb-8 h-[calc(100vh-80px)] w-full pl-3 xl:mt-[2px] xl:h-auto xl:w-1/2 xl:px-1.5">
          <h3 className="pb-0 pt-3 font-miSansDemiBold450 text-xl leading-[24px] text-black xl:py-1">
            {t('quick_link')}
          </h3>
          <ul>
            {quickLinkList?.map((item, index) => (
              <li key={index} className="mt-2.5 py-1">
                <Link href={item.link} className="flex items-center">
                  <span className="mr-[2px]">
                    <DirectionIcon width={16} height={16} color="#000" />
                  </span>
                  <span className="overflow-hidden text-ellipsis whitespace-nowrap font-miSansRegular330 text-base leading-[24px] text-black">
                    {item.term}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  )
}

export default QuickLink
